interface SuccessStateProps {
  userId: string;
  email?: string;
  method: string;
}

export const SuccessState = ({ userId, email, method }: SuccessStateProps) => {
  return (
    <div className='flex items-center justify-center min-h-[calc(100vh-12rem)]'>
      <div className='bg-gray-900 border border-gray-700 rounded-lg p-8 max-w-md w-full'>
        <div className='text-center mb-6'>
          <div className='text-6xl mb-4'>✅</div>
          <h1 className='text-2xl font-bold text-white'>Logged in successfully!</h1>
        </div>

        <div className='space-y-3 text-sm'>
          <div className='flex justify-between border-b border-gray-800 pb-2'>
            <span className='text-gray-400'>User ID:</span>
            <span className='text-white font-mono'>{userId}</span>
          </div>

          {email && (
            <div className='flex justify-between border-b border-gray-800 pb-2'>
              <span className='text-gray-400'>Email:</span>
              <span className='text-white'>{email}</span>
            </div>
          )}

          <div className='flex justify-between border-b border-gray-800 pb-2'>
            <span className='text-gray-400'>Method:</span>
            <span className='text-green-400 font-semibold'>{method}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
